var React = require('react');

function CheckboxInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"9.5","y":"9.5","width":"24","height":"24","rx":"3.5","stroke":"#B3B9C7","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M15 19L21.5 25.5L38 9","stroke":"url(#paint0_linear)","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("defs",{"key":2},React.createElement("linearGradient",{"id":"paint0_linear","x1":"15","y1":"17.25","x2":"37.9945","y2":"17.6057","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#EA04FE","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#0025DD","key":1})]))]);
}

CheckboxInline.defaultProps = {"width":"43","height":"43","viewBox":"0 0 43 43","fill":"none"};

module.exports = CheckboxInline;

CheckboxInline.default = CheckboxInline;
